import React, { useMemo } from "react";
import moment from "moment";
import TableContainer from "./TableContainer";
import PatientLoader from "../../../common/PatientLoader";
import "./PatientsListDataTableStyles.css";
import { capitalize } from "lodash";

const PatientListDataTable = ({
  hideDemoAccounts,
  last30Days,
  data,
  loading,
}) => {
  const normalizeRole = (role) => {
    return capitalize(role.replaceAll("_", " "));
  };
  let renderColumns = [
    {
      Header: "First Name",
      accessor: "first_name",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value || "-"}
          </span>
        );
      },
    },
    {
      Header: "Last Name",
      accessor: "last_name",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>{cell.value}</span>
        );
      },
    },
    {
      Header: "Created",
      accessor: "created",
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return new Date(b?.values?.created) - new Date(a?.values?.created);
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value
              ? moment(cell.value).format("MMM Do, YYYY")
              : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Email",
      accessor: "email",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{cell.value}</span>;
      },
    },
    {
      Header: "Group",
      accessor: (d) => d.clinic,
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <span>
            {cell.value?.clinic_group?.contact_name || "Not Specified"}
          </span>
        );
      },
    },
    {
      Header: "Clinic",
      accessor: "clinic",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{cell.value?.name || "Not Specified"}</span>;
      },
    },
  ];

  const columns = useMemo(() => renderColumns, [loading]);

  return (
    <>
      {loading ? (
        <PatientLoader />
      ) : (
        <TableContainer
          columns={columns}
          data={data}
          last30Days={last30Days}
          hideDemoAccounts={hideDemoAccounts}
        />
      )}
    </>
  );
};

export default PatientListDataTable;
